export default class ProviderBackgroundGalleryModel {
    public userId: string = "";
    public fileBackground_1: Blob | null = null;
    public fileBackground_2: Blob | null = null;
    public fileBackground_3: Blob | null = null;
    public fileBackground_4: Blob | null = null;

    public constructor (userId: string) {
        this.userId = userId;
    }
}